import { getToken } from "firebase/messaging";
import { getFirebaseMessaging } from "../firebase/config";
import { RuntimeConfig } from "../runtimeConfig";
import { logger } from "@/lib/logger";

/**
 * Get FCM token from Firebase
 * @returns FCM token or null if permission not granted or error
 */
export async function getFcmToken(): Promise<string | null> {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      logger.warn("Notification permission not granted");
      return null;
    }

    const messaging = await getFirebaseMessaging();

    if (!messaging) {
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: RuntimeConfig.FIREBASE_VAPID_KEY,
    });

    return token || null;
  } catch (error) {
    if (
      error instanceof Error &&
      (error.name === "AbortError" || error.message.includes("push service"))
    ) {
      logger.warn(
        "Push service unavailable (requires HTTPS or valid VAPID key)",
      );
      return null;
    }

    logger.error("Error getting FCM token:", error);
    return null;
  }
}
